import React from "react";
import "./smallModal.css";
import functionDate from "../../utils/formatarData";
import Textnotifications from "../../utils/notifications";
import SmallModalNaladi from "../fluxo-tax/smallModalNaladi/smallModalNaladi";

interface NaladiModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  naladiCode: string;
  setNaladiCode: (value: string) => void;
  isButtonDisabled: boolean;
  onDisableButton: (disabled: boolean) => void;
  isSubmitting: boolean;
  ncmApiError: string | null;
  setNcmApiError: (value: string | null) => void;
  mode: "material" | "tax";
}

export const NaladiModal: React.FC<NaladiModalProps> = ({
  open,
  onClose,
  onConfirm,
  naladiCode,
  setNaladiCode,
  isButtonDisabled,
  onDisableButton,
  isSubmitting,
  ncmApiError,
  setNcmApiError,
  mode,
}) => {
  return (
    <SmallModalNaladi
      titleModal="Correção de NALADI"
      inputMotivo="sim"
      titleLabel="Explique o motivo"
      inputNaladiNCM="sim"
      titleDescription={
        <div
          className="space titleAprover"
          dangerouslySetInnerHTML={{
            __html:
              mode === "material"
                ? functionDate.formatBodyText(
                    Textnotifications.getNaladiPrompt()
                  )
                : functionDate.formatKey(Textnotifications.getNaladiPrompt()),
          }}
        />
      }
      bodyModal=""
      buttonOne="Corrigir"
      onConfirm={onConfirm}
      buttonTwo="Cancelar"
      onClose={onClose}
      naladiCode={naladiCode}
      setNaladiCode={setNaladiCode}
      isButtonDisabled={isButtonDisabled}
      onDisableButton={onDisableButton}
      isSubmitting={isSubmitting}
      ncmError={ncmApiError}
      setNcmError={setNcmApiError}
    />
  );
};
